var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      ref: "modal",
      attrs: { heading: "Pass Applicant/s on " + _vm.phaseName }
    },
    [
      _c("div", { staticClass: "grid-x grid-padding-x" }, [
        _c("div", { staticClass: "cell shrink" }, [
          _vm._v(
            "\n            Are you sure you want to pass the " +
              _vm._s(_vm.jobApplications.length) +
              " selected applicants to the next phase?\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x" }, [
        _vm.phase === "loading_offer"
          ? _c(
              "div",
              { staticClass: "cell col-12 text-left" },
              [
                _c("strong", [_vm._v("Onboarding Invitation")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Invite candidate to an orboarding session. Please specify the details of the boarding session\n                below:"
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v("Date & Time")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.onboarding_datetime,
                      expression: "data.onboarding_datetime"
                    }
                  ],
                  attrs: { type: "datetime-local", required: "" },
                  domProps: { value: _vm.data.onboarding_datetime },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.data,
                        "onboarding_datetime",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v("Venue/ location")]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.venue,
                      expression: "data.venue"
                    }
                  ],
                  attrs: { required: "" },
                  domProps: { value: _vm.data.venue },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "venue", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v("Google maps link ")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.google_maps_link,
                      expression: "data.google_maps_link"
                    }
                  ],
                  attrs: { type: "text", required: "" },
                  domProps: { value: _vm.data.google_maps_link },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.data,
                        "google_maps_link",
                        $event.target.value
                      )
                    }
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v("Contact Person")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.contact_person,
                      expression: "data.contact_person"
                    }
                  ],
                  attrs: { type: "text", required: "" },
                  domProps: { value: _vm.data.contact_person },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "contact_person", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v("Contact Number")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.contact_number,
                      expression: "data.contact_number"
                    }
                  ],
                  attrs: { type: "text", required: "" },
                  domProps: { value: _vm.data.contact_number },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "contact_number", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v("Other Notes")]),
                _vm._v(" "),
                _c("RedactorControlVue", {
                  model: {
                    value: _vm.data.notes,
                    callback: function($$v) {
                      _vm.$set(_vm.data, "notes", $$v)
                    },
                    expression: "data.notes"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.phase === "onboarding"
          ? _c("div", { staticClass: "cell col-12 text-left" }, [
              _c("br"),
              _vm._v(" "),
              _c("strong", [
                _vm._v("Did the candidate attend the onboarding session?")
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [_vm._v("Start Date")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.job_offer_start_date,
                    expression: "data.job_offer_start_date"
                  }
                ],
                attrs: { type: "datetime-local", required: "" },
                domProps: { value: _vm.data.job_offer_start_date },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.data,
                      "job_offer_start_date",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm._v(" "),
              _c("br")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
        _c("div", { staticClass: "cell shrink" }, [
          _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
            _c("div", { staticClass: "cell shrink" }, [
              _c(
                "button",
                {
                  staticClass: "button success",
                  attrs: { type: "button" },
                  on: { click: _vm.pass }
                },
                [_vm._v("Pass")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell shrink" }, [
              _c(
                "button",
                {
                  staticClass: "button warning",
                  attrs: { type: "button" },
                  on: { click: _vm.toggleModal }
                },
                [_vm._v("Close")]
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3205702c", { render: render, staticRenderFns: staticRenderFns })
  }
}